export enum SlideType {
    DATE,
    GAME,
    PLAYOFF_ROUND,
    SERIES,
    DRAFT_PICK,
}
